<template>
  <SettingPanel title="Close by bot time" :loading="isLoading">
    <template #edit="{ done }">
      <CloseByBotManagement :setting="data" @updateSetting="data = $event" @onClose="done()" />
    </template>

    {{ data.close_by_bot_duration_time }} Sec
  </SettingPanel>
</template>

<script>
import SettingPanel from './SettingPanel.vue'
import CloseByBotManagement from './CloseByBotManagement.vue'
import ticket3PageApi from '@/api/ticket3/page'
import { handleApiError } from '@/api/util'
import { mapGetters } from 'vuex'

export default {
  components: { SettingPanel, CloseByBotManagement },
  data() {
    return {
      data: {
        close_by_bot_duration_time: 30
      },
      isLoading: true
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    })
  },
  created() {
    this.handleGetCloseByBotTime()
  },
  methods: {
    async handleGetCloseByBotTime() {
      try {
        this.isLoading = true

        const response = await ticket3PageApi.getCloseByBotTime({
          params: {
            page_id: this.selectedBot.pageid
          }
        })

        if (response.status === 200) {
          this.data = response.data
        }
      } catch (error) {
        handleApiError(error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/ticket-management/Setting/CloseByBot.vue